export const cookie = {
  title: 'Cookiebeleid',
  lastUpdated: 'Laatst bijgewerkt: januari 2025',
  
  intro: {
    title: 'Inleiding',
    text: 'Dit Cookiebeleid legt uit hoe NovaVenture Group BV ("wij", "ons", "onze") cookies en vergelijkbare technologieën gebruikt op onze website. Door onze website te gebruiken, gaat u akkoord met het gebruik van cookies zoals beschreven in dit beleid.'
  },

  whatAreCookies: {
    title: 'Wat zijn cookies?',
    text: 'Cookies zijn kleine tekstbestanden die op uw apparaat (computer, tablet of smartphone) worden geplaatst wanneer u een website bezoekt. Cookies helpen websites om uw voorkeuren te onthouden en de functionaliteit van de website te verbeteren.'
  },

  cookiesWeUse: {
    title: 'Welke cookies gebruiken wij?',
    intro: 'Op dit moment gebruikt NovaVenture Group BV uitsluitend strikt noodzakelijke functionele cookies. Wij gebruiken geen tracking-, analyse- of marketingcookies.',
    
    necessary: {
      title: 'Strikt noodzakelijke cookies',
      description: 'Deze cookies zijn essentieel voor het correct functioneren van onze website. Zonder deze cookies kan de website niet goed werken. Deze cookies verzamelen geen persoonlijke informatie en kunnen niet worden uitgeschakeld.',
      examplesLabel: 'Voorbeelden:',
      examples: 'Sessiecookies, taalvoorkeur, beveiligingscookies'
    },

    noTracking: {
      title: 'Geen tracking- of marketingcookies',
      description: 'Wij gebruiken momenteel geen cookies voor tracking, analyse of marketing doeleinden. Uw surfgedrag wordt niet gevolgd en er worden geen profielen van u aangemaakt.'
    }
  },

  futureTracking: {
    title: 'Toekomstig gebruik van tracking cookies',
    text: 'Mochten wij in de toekomst besluiten om tracking-, analyse- of marketingcookies te gebruiken, dan zullen wij vooraf uw uitdrukkelijke toestemming vragen via een cookiebanner. U heeft dan de mogelijkheid om deze cookies te accepteren of te weigeren.'
  },

  manageCookies: {
    title: 'Cookies beheren',
    intro: 'U kunt cookies beheren via de instellingen van uw webbrowser. De meeste browsers bieden de mogelijkheid om:',
    browsers: {
      chrome: 'Google Chrome: Instellingen > Privacy en beveiliging > Cookies en andere sitegegevens',
      firefox: 'Mozilla Firefox: Instellingen > Privacy en beveiliging > Cookies en sitegegevens',
      safari: 'Safari: Voorkeuren > Privacy > Cookies en websitegegevens',
      edge: 'Microsoft Edge: Instellingen > Cookies en sitemachtigingen'
    },
    warning: 'Let op: Het uitschakelen van strikt noodzakelijke cookies kan de functionaliteit van onze website beperken.'
  },

  updates: {
    title: 'Wijzigingen in dit cookiebeleid',
    text: 'Wij behouden ons het recht voor om dit Cookiebeleid te wijzigen. Eventuele wijzigingen worden op deze pagina gepubliceerd. Wij raden u aan dit beleid regelmatig te raadplegen om op de hoogte te blijven van eventuele wijzigingen.'
  },

  contact: {
    title: 'Contact',
    intro: 'Heeft u vragen over ons Cookiebeleid? Neem dan contact met ons op:'
  },

  moreInfo: {
    title: 'Meer informatie',
    intro: 'Voor meer informatie over hoe wij met uw gegevens omgaan, verwijzen wij u naar:',
    privacyLink: 'Privacybeleid',
    termsLink: 'Algemene Voorwaarden'
  }
};